import { LEGAL_LINK_LIST, legalAbsoluteUrl } from '@/lib/legalLinks';

/**
 * KickstartV2Footer — race-bib numbered legal links + brand block.
 *
 * Mirror of the marketing Footer (src/surfaces/marketing/v2/sections/Footer.tsx)
 * so the brand reads consistent end-to-end (cold ad → Kickstart → OS).
 *
 * Links resolve to the canonical theaibrandlab.com origin since Kickstart
 * lives on `kickstart.theaibrandlab.com` (cross-origin from the marketing
 * surface). Open in the same window — these are reference docs, not deep
 * destinations the user is meant to bounce back from.
 */
export default function KickstartV2Footer() {
  return (
    <footer className="border-t-[1.5px] border-fd-text bg-fd-text text-fd-bg">
      <div className="mx-auto max-w-[1280px] px-4 py-12 sm:px-6 sm:py-14 lg:px-8">
        <div className="grid gap-10 sm:grid-cols-[1fr_auto] sm:gap-16">
          {/* Brand block */}
          <div className="font-geist-mono text-[12px] font-semibold uppercase tracking-[0.06em] text-[oklch(0.74_0.005_95)] sm:text-[13px]">
            <p className="text-fd-bg">© 2026 AI Brand Lab</p>
            <p className="mt-1.5 text-[oklch(0.62_0.005_95)]">
              Kickstart ·{' '}
              <a
                href="https://theaibrandlab.com"
                className="text-fd-accent hover:underline"
              >
                theaibrandlab.com
              </a>
            </p>
          </div>

          {/* Legal links — race-bib numbered, absolute URLs to marketing origin */}
          <nav aria-label="Legal" className="min-w-[180px]">
            <p className="mb-3 font-geist-mono text-[10.5px] font-semibold uppercase tracking-[0.12em] text-[oklch(0.56_0.005_95)]">
              Legal
            </p>
            <ul className="grid grid-cols-2 gap-x-8 gap-y-1.5 sm:grid-cols-1">
              {LEGAL_LINK_LIST.map((link) => (
                <li key={link.slug}>
                  <a
                    href={legalAbsoluteUrl(link.slug)}
                    className="group inline-flex items-baseline gap-2 font-geist text-[13.5px] text-[oklch(0.78_0.005_95)] transition-colors hover:text-fd-bg"
                  >
                    <span className="font-geist-mono text-[10.5px] tabular-nums text-[oklch(0.56_0.005_95)] transition-colors group-hover:text-[oklch(0.74_0.005_95)]">
                      {link.number}
                    </span>
                    <span>{link.shortTitle}</span>
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </footer>
  );
}
